/**
 * LoadingScreen - Loading state component
 * 
 * Displays loading spinner and message during authentication
 */

import React from 'react';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="glass-panel glass-panel--tight w-full max-w-md text-center">
        <div className="glass-panel__content">
          <div className="loading-spinner mb-6" />
          <h1 className="text-lg font-semibold text-glass-primary mb-2">{message}</h1>
          <p className="text-glass-muted text-sm uppercase tracking-[0.24em]">
            This may take a few moments
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 
